export default __webpack_public_path__ + "static/media/emptyAirline.e7788029.png";